import cn from 'classnames'
import React from 'react'
import styles from './veil.module.less'

export const Veil: React.FC<React.PropsWithChildren & { active?: boolean }> = ({ children, active }) =>
    active ? <div className={cn(styles.root, styles.active)}>{children}</div> : children